export const scrollPrevent = (isPrevent:boolean) => {
    document.body.style.overflowY = isPrevent ? "hidden" : "scroll";
};